import { render } from "./equipos.vue?vue&type=template&id=07b37bec"
import script from "./equipos.vue?vue&type=script&lang=js"
export * from "./equipos.vue?vue&type=script&lang=js"

import "./equipos.vue?vue&type=style&index=0&id=07b37bec&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__